import React, {Component} from "react";
import Proptypes from "prop-types";


class ServiceBotSignup extends Component {
    componentDidMount() {
        (function () {
            var s = document.createElement('script');
            s.src = 'https://js.servicebot.io/embeds/servicebot-billing-settings-embed.js';
            s.async = true;
            s.type = 'text/javascript';
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        })();
    }

    render() {
        window.servicebotSettings = {
            servicebot_id: "OJ7ZpGRwFZ2c", // LIVE & TEST MODE IDs ARE DIFFERENT
            options: {
                behavior: {
                    signup: {
                        "showAsPage": true,
                        "allowChooseAnotherPlan": true,
                        "afterSuccessfulSignup": "success_message"
                    },
                    payments: {
                        stripeElement: {
                            "useDefault": true,
                        }
                    }
                },
                card: {
                    hideAddress: true,
                    hideCountryPostal: true
                }
            },
            service: "Kasm Disposables",
            interval: "month",
            type: "signup",
            integration: "html",
            email: this.props.email,
            hash: this.props.hash,

        };

        return (
            <div id="servicebot-subscription-portal"></div>
        );
    }
}


ServiceBotSignup.propTypes = {
    email: Proptypes.string.isRequired
};

export default ServiceBotSignup


// WEBPACK FOOTER //
// ./src/components/ServiceBot/Signup/Signup.js